import React, { Component } from "react";
import cloneDeep from "lodash/cloneDeep";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import FormField from "@cloudscape-design/components/form-field";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Toggle from "@cloudscape-design/components/toggle";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { chatPinnedAddModalStore, tournamentsBannersAddModalStore } from "../stores/chatPinnedAddModal";
import { chatPinnedStore } from "../stores/chatPinned";

import DateTimeSelector from "../utils/component/DateTimeSelector";

class ChatPinnedAddModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		};
	}
	componentDidUpdate(prevProps) {
		if (!prevProps.chatPinnedAddModal.show && this.props.chatPinnedAddModal.show) {
			this.resetFormFields();
		}
	}

	addChatPinned() {
		if (this.props.chatPinnedAddModal.isClickable && (typeof this.props.chatPinnedAddModal.link !== "string" || this.props.chatPinnedAddModal.link.trim() === "")) {
			this.props.Interface.addNoty("Error", "Internal link is required for clickable pinned messages");
			return;
		}

		if (this.props.chatPinnedAddModal.lastDisplayedTime === null || this.props.chatPinnedAddModal.lastDisplayedDate === null) {
			this.props.Interface.addNoty("Error", "Selected date and time");
			return;
		}
		this.setState({
			loading: true,
		});

		this.props.Interface.request(
			"set",
			{
				class: "data",
				module: "chatPinned",
				method: "add",
			},
			{ ...this.props.chatPinnedAddModal, messageType: this.props.chatPinnedAddModal.messageType.value, lastDisplayed: `${this.props.chatPinnedAddModal.lastDisplayedDate}T${this.props.chatPinnedAddModal.lastDisplayedTime}` },
		)
			.then((result) => {
				this.setState({
					loading: false,
				});
				this.props.Interface.addNoty("Success", "Chat pinned was successfully added");
				this.props.Interface.loadChatPinnedList();
				this.resetFormFields();
			})
			.catch((error) => {
				if (typeof error.text === "undefined") error = { text: error.toString() };
				this.props.setChatPinned({ ...this.props.chatPinned, loaded: true, error });

				this.setState({
					loading: false,
				});
			});
	}

	resetFormFields = () => {
		this.props.setChatPinnedAddModal({
			...this.props.chatPinnedAddModal,
			message: "",
			messageType: "",
			isClickable: false,
			link: "",
			show: false,
			type: false,
			status: false,
			durationMinutes: 0,
			intervalMinutes: 0,
			lastDisplayedDate: null,
			lastDisplayedTime: null,
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
		});
	};

	updateParam = (key, value) => {
		const updatedState = cloneDeep(this.props.chatPinnedAddModal);
		updatedState[key] = value;
		this.props.setChatPinnedAddModal(updatedState);
	};

	render() {
		const { chatPinnedAddModal, setChatPinnedAddModal } = this.props;
		return (
			<Modal
				visible={chatPinnedAddModal.show}
				onDismiss={() => setChatPinnedAddModal({ ...chatPinnedAddModal, show: false })}
				header="Add pinned message"
				children={
					<SpaceBetween direction="vertical" size="m">
						<Box variant="span">Message</Box>
						<Input
							name="Title"
							autoComplete="off"
							inputMode="text"
							type="text"
							disableBrowserAutocorrect={true}
							placeholder="Message"
							value={chatPinnedAddModal.message}
							onChange={(event) =>
								setChatPinnedAddModal({
									...chatPinnedAddModal,
									message: event.detail.value,
								})
							}
						/>
						<Box variant="span">Message translation type</Box>
						<Select placeholder="Select type" selectedOption={chatPinnedAddModal.messageType} onChange={(option) => this.updateParam("messageType", option.detail.selectedOption)} options={chatPinnedAddModal.currentOption.messageType} />
						<Toggle checked={chatPinnedAddModal.isClickable} onChange={({ detail }) => this.updateParam("isClickable", detail.checked)}>
							{chatPinnedAddModal.isClickable ? "Clickable" : "Not clickable"}
						</Toggle>
						{chatPinnedAddModal.isClickable && (
							<FormField label="Internal link" errorText={chatPinnedAddModal.link.startsWith("/") ? "Enter the internal path without a leading /, e.g. promo" : undefined}>
								<Input
									name="Link"
									autoComplete="off"
									inputMode="url"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="Internal link"
									value={chatPinnedAddModal.link}
									onChange={(event) =>
										setChatPinnedAddModal({
											...chatPinnedAddModal,
											link: event.detail.value,
										})
									}
								/>
							</FormField>
						)}
						<Box variant="span">Type</Box>
						<Select filteringType="auto" placeholder="Select type" selectedOption={chatPinnedAddModal.type} onChange={(option) => this.updateParam("type", option.detail.selectedOption)} options={chatPinnedAddModal.currentOption.type} />
						{chatPinnedAddModal.type.value === "interval" && (
							<>
								<Box variant="span">Duration minutes</Box>
								<Input
									name="durationMinutes"
									autoComplete="off"
									inputMode="number"
									type="number"
									disableBrowserAutocorrect={true}
									placeholder="Duration minutes"
									value={chatPinnedAddModal.durationMinutes}
									onChange={(event) =>
										setChatPinnedAddModal({
											...chatPinnedAddModal,
											durationMinutes: event.detail.value,
										})
									}
								/>
								<Box variant="span">Interval minutes</Box>
								<Input
									name="intervalMinutes"
									autoComplete="off"
									inputMode="number"
									type="number"
									disableBrowserAutocorrect={true}
									placeholder="Interval minutes"
									value={chatPinnedAddModal.intervalMinutes}
									onChange={(event) =>
										setChatPinnedAddModal({
											...chatPinnedAddModal,
											intervalMinutes: event.detail.value,
										})
									}
								/>
							</>
						)}
						<Box variant="span">Last displayed</Box>
						<DateTimeSelector
							onTimeChange={(time) => {
								setChatPinnedAddModal({
									...chatPinnedAddModal,
									lastDisplayedTime: time,
								});
							}}
							onDateChange={(date) => {
								setChatPinnedAddModal({
									...chatPinnedAddModal,
									lastDisplayedDate: date,
								});
							}}
						/>
						<Box variant="span">Status</Box>
						<Select filteringType="auto" placeholder="Select status" selectedOption={chatPinnedAddModal.status} onChange={(option) => this.updateParam("status", option.detail.selectedOption)} options={chatPinnedAddModal.currentOption.status} />
					</SpaceBetween>
				}
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="m">
							<Button variant="normal" onClick={() => setChatPinnedAddModal({ ...chatPinnedAddModal, show: false })} children="Close" />
							<Button variant="primary" disabled={this.state.loading} onClick={() => this.addChatPinned()} children="Ok" />
						</SpaceBetween>
					</Box>
				}
			/>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const chatPinnedAddModal = useRecoilValue(chatPinnedAddModalStore);
		const setChatPinnedAddModal = useSetRecoilState(chatPinnedAddModalStore);
		const chatPinned = useRecoilValue(chatPinnedStore);
		const setChatPinned = useSetRecoilState(chatPinnedStore);
		return <Component {...props} chatPinned={chatPinned} setChatPinned={setChatPinned} setChatPinnedAddModal={setChatPinnedAddModal} chatPinnedAddModal={chatPinnedAddModal} />;
	};
}

export default withRecoil(ChatPinnedAddModal);
